import { prefixObjectValues } from '../utils';

const requestForm = {
  form: 'peer-request-form',
  firstName: 'firstName',
  lastName: 'lastName',
  emailAddress: 'emailAddress',
  phoneNumber: 'phoneNumber',
  faxNumber: 'faxNumber',
  relationshipType: 'relationshipType',
  occupation: 'occupation',
  shareFormFlag: 'shareFormCheck',
  submitBtn: '-submit-button',
  closeBtn: '-close-button',
};

export default prefixObjectValues(requestForm, 'peer-reference--request-form');
